module.exports = __webpack_public_path__ + "static/media/EM1.85121c40.png";